import React from "react";
import { useFormContext } from "react-hook-form";
import { Box } from "@mui/material";
import { MTextField, ResponsiveFormContainer } from "@app/components";
import PreparationCommon from "../../../commonForms/preparation";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";

const Tracking = () => {
  const form = useFormContext();
  const { currentPreparation } = useAnalysis();
  return (
    <Box mt={2} px={4}>
      <PreparationCommon />

      <ResponsiveFormContainer columns={5} mt={2}>
        <MTextField
          key={JSON.stringify(form.getValues("analyzedAirVolume"))}
          name="analyzedAirVolume"
          label="Volumen aire analizado (m3)"
          placeholder="Volumen aire analizado (m3)"
          type="number"
          fullWidth
          disabled
        />
        <MTextField
          key={JSON.stringify(form.getValues("analyzedWaterVolume"))}
          name="analyzedWaterVolume"
          label="Volumen agua analizado (ml)"
          placeholder="Volumen agua analizado (ml)"
          type="number"
          fullWidth
          validation={{ required: "El volumen de agua analizado es requerido" }}
          disabled={!currentPreparation.canEdit}
        />
      </ResponsiveFormContainer>
    </Box>
  );
};

export default Tracking;
